<div class="special-columns-editor mt-3">
  <label class="form-check-label fw-bold">{{ 'SPECIAL-COLUMN.TITLE' | translate }}</label>

  @for (sc of specialColumns; track sc; let ci = $index) {
    <div class="border rounded p-2 mb-2">
      <div class="d-flex gap-2 mb-2">
        <input type="text" class="form-control" name="scName{{ci}}"
          [placeholder]="'SPECIAL-COLUMN.NAME' | translate" [(ngModel)]="sc.name" (ngModelChange)="notifyChange()">
        <input type="text" class="form-control" name="scSep{{ci}}" style="max-width:140px;"
          [placeholder]="'SPECIAL-COLUMN.SEPARATOR' | translate" [(ngModel)]="sc.separator" (ngModelChange)="notifyChange()">
        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeColumn(ci)">
          {{ 'SPECIAL-COLUMN.REMOVE' | translate }}
        </button>
      </div>
      @if (showErrors && isInvalid(sc)) {
        <div class="text-danger small mb-2">
          {{ 'SPECIAL-COLUMN.INCOMPLETE' | translate }}
        </div>
      }
      @for (src of sc.sources; track src; let si = $index) {
        <div class="d-flex gap-2 mb-1 align-items-center">
          <select class="form-control" name="scSrc{{ci}}_{{si}}" [(ngModel)]="src.name" (ngModelChange)="onSourceColumnChange(ci, si)">
            <option value="">{{ 'SPECIAL-COLUMN.SOURCE' | translate }}</option>
            @for (col of sourceColumns; track col) {
              <option [value]="col.name">{{ col.name }}</option>
            }
          </select>
          @if (isDateColumn(src.name)) {
            <select class="form-control" style="max-width:160px;"
              name="scPart{{ci}}_{{si}}" [(ngModel)]="src.datePart" (ngModelChange)="notifyChange()">
              <option value="year">{{ 'SPECIAL-COLUMN.YEAR' | translate }}</option>
              <option value="fulldate">{{ 'SPECIAL-COLUMN.FULL_DATE' | translate }}</option>
            </select>
          }
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="removeSource(ci, si)">&times;</button>
        </div>
      }
      <button type="button" class="btn btn-sm btn-outline-primary mt-1" (click)="addSource(ci)">
        {{ 'SPECIAL-COLUMN.ADD_SOURCE' | translate }}
      </button>
    </div>
  }

  <button type="button" class="btn btn-sm btn-secondary" (click)="addColumn()">
    {{ 'SPECIAL-COLUMN.ADD' | translate }}
  </button>
</div>
